import {toast} from "react-toastify";
import {Contentbar} from "../../../ui/Sidebar";
import useDrawer from "../../../hooks/useDrawer";
import {useDeleteUserMutation} from "./__generated__/UserDelete.mutation.generated";

const UserDelete = () => {
  const { id, closeRootHandler, closeChildrenHandler } = useDrawer();

  const [deleteHandler, { loading }] = useDeleteUserMutation({
    variables: { id },
    onCompleted: () => {
      toast.success('Удаление выполнено!');
      closeRootHandler();
      closeChildrenHandler();
    },
    onError: () => {
      toast.error('При удалении произошла ошибка');
    }
  })

  return (
    <Contentbar onClose={closeChildrenHandler} isLoading={loading} onSubmit={deleteHandler}>
      <h2>Вы точно уверены?</h2>
      <p><b>Внимание!</b> Удаление происиходит безвовратно, удаленые данные восстановлению не подлежать.</p>
      <p><b>Внимание!</b> После удаления пользователя удалятся все его объявления и заказы.</p>
      <p>Для продолжения нажмите кнопку <b>"Подтвердить".</b></p>
    </Contentbar>
  )
}

export default UserDelete;
